import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from 'app/navigation/navigation';
import { SystemService } from '../../../services/system.service';
import { Usuario } from '../../../interfaces/interfaces';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {FormGroup} from '@angular/forms';
import {MonthDialogComponent} from './month-dialog/month-dialog.component';
import {DraftService} from '../../../services/draft.service';
import {BillComponent} from '../../../components/bill/bill.component';

@Component({
    selector     : 'toolbar',
    templateUrl  : './toolbar.component.html',
    styleUrls    : ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy
{
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];



    // Private
    private _unsubscribeAll: Subject<any>;
    public user: Usuario;
    private dialogRef: any;
    public drafts: any[] = [];


    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private _matDialog: MatDialog,
        private _matSnackBar: MatSnackBar,
        private _router: Router,
        public _systemService: SystemService,
        public _draftService: DraftService
    )
    {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon : 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon : 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon : 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon : 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon : 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id   : 'en',
                title: 'English',
                flag : 'us'
            },
            {
                id   : 'tr',
                title: 'Turkish',
                flag : 'tr'
            },
            {
                id   : 'es',
                title: 'Español',
                flag : 'uy'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});
        this.user = this._systemService.usuario;
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void
    {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void
    {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void
    {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    logout(): void {
        this._systemService.logout();
        this._router.navigateByUrl('/');
    }

    exportarHH(): void {
        this.dialogRef = this._matDialog.open(MonthDialogComponent, {
            panelClass: 'month-dialog',
            data      : {
                action: 'new'
            }
        });

        this.dialogRef.afterClosed()
            .subscribe(
                (response: FormGroup) => {
                    if (response){
                        this._matSnackBar.open('Exportando....', '',  {
                            duration: 10000,
                            horizontalPosition: 'end',
                            verticalPosition: 'top'
                        });
                        const aux = response.getRawValue();
                        this._systemService.exportImport('HH', aux.year, aux.month).subscribe(
                            resp => {
                                this._matSnackBar.open('Pronto!', 'OK',  {
                                    duration: 60000,
                                    horizontalPosition: 'end',
                                    verticalPosition: 'top'
                                });
                            }
                        );
                    }

                });


    }

    exportarEntidades(): void {
        this._matSnackBar.open('Exportando....', '',  {
            duration: 10000,
            horizontalPosition: 'end',
            verticalPosition: 'top'
        });
        this._systemService.exportImport('Entities', 0, 0).subscribe(
            resp => {
                this._matSnackBar.open('Pronto!', 'OK',  {
                    duration: 60000,
                    horizontalPosition: 'end',
                    verticalPosition: 'top'
                });
            }
        );
    }

    // importarMontos(): void {
    //     this._matSnackBar.open('Importando....', '',  {
    //         duration: 10000,
    //         horizontalPosition: 'end',
    //         verticalPosition: 'top'
    //     });
    //     this._systemService.exportImport('Montos', 0, 0).subscribe(
    //         resp => {
    //             this._matSnackBar.open('Pronto!', 'OK',  {
    //                 duration: 60000,
    //                 horizontalPosition: 'end',
    //                 verticalPosition: 'top'
    //             });
    //         }
    //     );
    // }

    importFiles(): void{
        // Crear elemento input de tipo file de manera programática
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.xlsx,.xls,.csv'; // Ajusta las extensiones según tus necesidades

        // Manejar la selección del archivo
        input.onchange = (event: any) => {
            const file = event.target.files[0];

            if (file) {
                // Mostrar mensaje de carga
                this._matSnackBar.open('Importando archivo...', '', {
                    duration: 10000,
                    horizontalPosition: 'end',
                    verticalPosition: 'top'
                });

                // Crear FormData para enviar el archivo
                const formData = new FormData();
                formData.append('file', file);

                // Llamar al servicio para subir el archivo
                this._systemService.importFile(formData).subscribe(
                    resp => {
                        this._matSnackBar.open('¡Archivo importado correctamente!', 'OK', {
                            duration: 5000,
                            horizontalPosition: 'end',
                            verticalPosition: 'top'
                        });
                    },
                    error => {
                        this._matSnackBar.open('Error al importar el archivo', 'OK', {
                            duration: 5000,
                            horizontalPosition: 'end',
                            verticalPosition: 'top'
                        });
                        console.error('Error:', error);
                    }
                );
            }
        };

        // Simular click en el input para abrir el selector de archivos
        input.click();
    }

    async updateDrafts(): Promise<void> {
        this.drafts = await this._draftService.getAllDrafts();
    }

    async loadDraft(draft: any): Promise<void> {
        this._matDialog.open(BillComponent, {
            panelClass: 'bill-dialog',
            data: draft
        });
    }

    formatDraftDate(date: any): string {
        return new Date(date).toLocaleString();
    }
}
